import { ComponentType, ForwardRefRenderFunction } from 'react';

const _displayName = (displayName?: string): string => displayName || 'Unknown';

/**
 * @author: Dumitrana Alinus <alin.designstudio@gmail.com>
 * @class: namedComponent
 * @date:  01.11.2019
 * @time:  05:11
 */
export const namedComponent = <P extends Record<string, any>, C extends ComponentType<P> = ComponentType<P>>(
    component: C,
    displayName?: string,
): C => {
    component.displayName = _displayName(displayName || component.displayName);
    return component;
};

/**
 * @author: Dumitrana Alinus <alin.designstudio@gmail.com>
 * @class: namedComponentRef
 * @date:  01.11.2019
 * @time:  06:09
 */
export const namedComponentRef = <
    P extends Record<string, any>,
    C extends ForwardRefRenderFunction<P> = ForwardRefRenderFunction<P>,
>(
    component: C,
    displayName?: string,
): C => {
    component.displayName = _displayName(displayName || component.displayName);
    return component;
};
